import { withInstall } from '@lit-element/utils'
import Switch from './src/switch.vue'
import type { SFCWithInstall } from '@lit-element/utils'

export const LtSwitch: SFCWithInstall<typeof Switch> = withInstall(Switch)
export default LtSwitch

export * from './src/switch'
